export default __webpack_public_path__ + "static/media/logo-wageworks.44c3973d.png";